// @flow

import React from 'react';
import type { Node, Element } from 'react';
import {
  Container,
  Box,
  Icon,
  Content,
  Title,
  Description,
  ButtonWrapper,
} from './iconTopBoxed.styled';
import { ACFButton } from '../../button';

type Props = {
  iconComponent: Node,
  title: string,
  description: string,
  largeIcon?: boolean,
  buttonComponent?: Element<typeof ACFButton> | null,
};

const IconTopBoxed = ({
  iconComponent,
  title,
  description,
  largeIcon = false,
  buttonComponent,
}: Props) => (
  <Container largeIcon={largeIcon}>
    <Box />
    <Icon largeIcon={largeIcon}>
      {iconComponent}
    </Icon>
    <Content>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Content>
    {buttonComponent && (
      <ButtonWrapper>
        {buttonComponent}
      </ButtonWrapper>
    )}
  </Container>
);

IconTopBoxed.defaultProps = {
  largeIcon: false,
  buttonComponent: null,
};

export default IconTopBoxed;
